import sortBy from "lodash/sortBy";
import CoreAPI from "../coreAPI";
import ResourceOrder, {
  ResourceOrderAPIResponse,
  ResourceOrderTypeNames,
  ResourceOrderTypes,
} from "../../classes/employerDashboard/resourceOrder";
import MarketingMaterialPostcard from "../../classes/employerDashboard/marketingMaterial/marketingMaterialPostCard";
import MarketingMaterialDemo from "../../classes/employerDashboard/marketingMaterial/marketingMaterialDemo";
import MarketingMaterialStandeeBenefitsFair from "../../classes/employerDashboard/marketingMaterial/marketingMaterialStandeeBenefitsFair";
import { MailingDetailsWithItemQuantity } from "../../classes/employerDashboard/mailingDetailsWithItemQuantity";
import MarketingMaterialPosters from "../../classes/employerDashboard/marketingMaterial/marketingMaterialPosters";
import MarketingMaterialBrochures from "../../classes/employerDashboard/marketingMaterial/marketingMaterialBrochures";

export default function APIOrder(coreAPI: CoreAPI) {
  return {
    async getOrders() {
      try {
        const response = await coreAPI.authCall<ResourceOrderAPIResponse[]>({
          endpoint: `/tenant/resources/orders`,
        });
        const orders = response.map((order) => ResourceOrder.fromAPI(order));
        return sortBy(orders, (order) => order.orderDate).reverse();
      } catch (e) {
        return [];
      }
    },
    async createOrder(resource: ResourceOrderTypes) {
      let resourceNames: string[] = [];
      let mailDate: string | null = null;
      let firstName: string | null = null;
      let lastName: string | null = null;
      let workEmail: string | null = null;
      let resourceOrderType: ResourceOrderTypeNames = "postcard";
      let addresses: MailingDetailsWithItemQuantity[] = [];

      // Postcards
      if (resource instanceof MarketingMaterialPostcard) {
        resourceNames = [resource.type];
        mailDate = resource.mailDate.toString();

        // Posters
      } else if (resource instanceof MarketingMaterialPosters) {
        resourceOrderType = "poster";
        resourceNames = [resource.posterType];
        addresses = resource.mailingDetails.map((details) => {
          return new MailingDetailsWithItemQuantity({
            ...details,
            standeeQuantity: 0,
            brochureQuantity: 0,
            posterQuantity: details.posterQuantity,
            cakeQuantity: 0,
          });
        });
      }
      // Brochures
      else if (resource instanceof MarketingMaterialBrochures) {
        resourceOrderType = "brochure";
        resourceNames = [resource.brochureType];
        addresses = resource.mailingDetails.map((details) => {
          return new MailingDetailsWithItemQuantity({
            ...details,
            standeeQuantity: 0,
            brochureQuantity: details.brochureQuantity,
            posterQuantity: 0,
            cakeQuantity: 0,
          });
        });
        // Standees and Video
      } else if (resource instanceof MarketingMaterialStandeeBenefitsFair) {
        resourceOrderType = "standees-and-video";
        resourceNames = [resource.type];
        addresses = [
          new MailingDetailsWithItemQuantity({
            ...resource.mailingDetails,
            standeeQuantity: 1,
            brochureQuantity: 0,
            posterQuantity: 0,
            cakeQuantity: 0,
          }),
        ];

        // Manifest Demo
      } else if (resource instanceof MarketingMaterialDemo) {
        resourceOrderType = "manifest-demo";
        firstName = resource.firstName;
        lastName = resource.lastName;
        workEmail = resource.workEmail;

        // Manifest Cake
      } else {
        resourceOrderType = "manifest-cake";
        resourceNames = [resource.type];
        addresses = [
          new MailingDetailsWithItemQuantity({
            ...resource.mailingDetails,
            standeeQuantity: 0,
            brochureQuantity: 0,
            posterQuantity: 0,
            cakeQuantity: 1,
          }),
        ];
      }
      return coreAPI.authCall({
        endpoint: `/resources/orders`,
        method: "POST",
        body: {
          resourceOrderType,
          resourceNames,
          orderDate: new Date(),
          mailDate,
          firstName,
          lastName,
          workEmail,
          addresses,
        },
      });
    },
  };
}
